/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { CalendarClock, Stethoscope, ListTree, UserCog } from 'lucide-react';
import { AvailabilityCalendar } from '@/components/AvailabilityCalendar';
import { AvailabilityListView } from '@/components/AvailabilityListView';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { toast } from 'sonner';
import logger from '@/lib/logger';
import { PageTitle } from '@/components/backoffice/PageTitle';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function GestioneDisponibilita() {
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState('');

  const fetchDoctors = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/doctors?active_only=false`);
      setDoctors(res.data);
    } catch (err) {
      logger.error('Doctors error:', err);
      toast.error('Errore nel caricamento dei dottori');
    }
  }, []);

  useEffect(() => { fetchDoctors(); }, [fetchDoctors]);

  const current = doctors.find(d => d.id === selectedDoctor);

  return (
    <div>
      <div className="mb-6">
        <PageTitle title="Disponibilità Dottori" info="Gestisci l'agenda di ogni dottore o consulta l'elenco completo degli slot per giorno o per studio." />
      </div>

      <Tabs defaultValue="gestione">
        <TabsList className="mb-4">
          <TabsTrigger value="gestione" className="gap-1.5" data-testid="dispo-tab-gestione"><UserCog size={15} /> Gestione per dottore</TabsTrigger>
          <TabsTrigger value="elenco" className="gap-1.5" data-testid="dispo-tab-elenco"><ListTree size={15} /> Elenco disponibilità</TabsTrigger>
        </TabsList>

        <TabsContent value="gestione">
          <Card className="mb-6">
            <CardContent className="p-4">
              <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                <Label className="flex items-center gap-1.5 whitespace-nowrap"><Stethoscope size={16} className="text-[#238A92]" /> Dottore</Label>
                <Select value={selectedDoctor} onValueChange={setSelectedDoctor}>
                  <SelectTrigger className="sm:w-96" data-testid="dispo-doctor-select">
                    <SelectValue placeholder="Seleziona un dottore" />
                  </SelectTrigger>
                  <SelectContent>
                    {doctors.map(d => (
                      <SelectItem key={d.id} value={d.id}>
                        Dott. {d.nome} {d.cognome}{d.specializzazione ? ` — ${d.specializzazione}` : ''}{d.active === false ? ' (inattivo)' : ''}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </CardContent>
          </Card>

          {selectedDoctor ? (
            <AvailabilityCalendar key={selectedDoctor} doctorId={selectedDoctor} />
          ) : (
            <Card>
              <CardContent className="p-12 text-center">
                <CalendarClock size={40} className="mx-auto text-[#238A92] mb-3" />
                <p className="text-lg font-semibold" style={{ fontFamily: 'Space Grotesk' }}>Nessun dottore selezionato</p>
                <p className="text-sm text-muted-foreground mt-1">Scegli un dottore dall'elenco per visualizzare e gestire la sua disponibilità.</p>
              </CardContent>
            </Card>
          )}
        </TabsContent>

        <TabsContent value="elenco">
          <AvailabilityListView doctors={doctors.filter(d => d.active !== false)} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
